import { WebRTC } from "./webrtc";
import { CameraSpeakerAction, MediaKind, SpeakerWebrtcAction } from "../common/base";
export class SpeakableWebRTC extends WebRTC {
    constructor(params, settings) {
        super(params, settings);
    }
    speakerPlay(param, callback) {
        return this.sendActionMessage(SpeakerWebrtcAction.PLAY, param, callback);
    }
    speakerConfigGet(token, macAddress, callback) {
        const req = {
            token: token,
            macAddress: macAddress,
            type: "get",
            object: MediaKind.AUDIO,
        };
        return this.sendActionMessage(SpeakerWebrtcAction.CONFIG, req, callback);
    }
    speakerConfigSet(token, macAddress, audioParams, callback) {
        if (audioParams) {
            if (!audioParams.jitterBuffer || (audioParams.jitterBuffer < 60 && audioParams.jitterBuffer > 2000)) {
                audioParams.jitterBuffer = 60;
            }
        }
        const req = {
            token: token,
            macAddress: macAddress,
            type: "set",
            object: MediaKind.AUDIO,
            audioParams: audioParams,
        };
        return this.sendActionMessage(SpeakerWebrtcAction.CONFIG, req, callback);
    }
    cameraSpeakerConfigGet(token, macAddress, remoteIndex, callback) {
        const req = {
            token: token,
            macAddress: macAddress,
            remoteIndex,
            type: "get",
            object: "output",
        };
        return this.sendActionMessage(CameraSpeakerAction.CONFIG, req, callback);
    }
    cameraSpeakerConfigSet(token, macAddress, remoteIndex, audioParams, callback) {
        const req = {
            token: token,
            macAddress: macAddress,
            remoteIndex,
            type: "set",
            object: "output",
            outputAudioParams: audioParams,
        };
        return this.sendActionMessage(CameraSpeakerAction.CONFIG, req, callback);
    }
}
